import r from "../../../@babel/runtime/helpers/esm/typeof.mjs";
function u(n) {
  return Array.isArray(n) ? n : n !== void 0 ? [n] : [];
}
var i = typeof window < "u" && window.document && window.document.documentElement, d = process.env.NODE_ENV !== "test" && i;
function f(n) {
  return n != null;
}
function t(n) {
  return ["string", "number"].includes(r(n));
}
function l(n) {
  var e = void 0;
  return n && (t(n.title) ? e = n.title.toString() : t(n.label) && (e = n.label.toString())), e;
}
export {
  l as getTitle,
  f as hasValue,
  d as isBrowserClient,
  i as isClient,
  u as toArray
};
//# sourceMappingURL=commonUtil.mjs.map
